module.exports = __webpack_public_path__ + "img/dominican_republic.6c5a97e.webp";